import vintageVibes from './vintage vibes.png'
import vintageVibes2 from './vintagevibes2.avif';
import vintageVibes3 from './vintageVibes3.avif';
import highRiseHustle from './high-rise hustle.png'
import highRiseHustle2 from './highrisehustle2.avif';
import highRiseHustle3 from './highrisehustle3.avif';
import blueJean from './blueJean.png';
import blueJeanTwo from './blueJean2.png';
import blueJeanThree from './blueJean3.avif';
import whiteJean1 from './whiteJean1.avif';
import whiteJean2 from './whiteJean2.avif';
import whiteJean3 from './whitejean3.avif'
import comfortCurves from './comfort curves.png';
import comfortCurves2 from './comfortCurves2.avif';
import comfortCurves3 from './comfortCurves3.avif';
import blackJean from './black jean.png';
import blackJean2 from './blackJean2.avif';
import blackJean3 from './blackJean3.avif';
import shirtWhite from './shirt white.png';
import shirtWhite2 from './shirtWhite2.avif';
import shirtWhite3 from './shirtWhite3.avif';
import shirtBlack from './shirt black.png';
import shirtGreen from './shirtGreen.avif';
import shirtGreen2 from './shirtGreen2.avif';
import shirtGreen3 from './shirtGreen3.avif';

import shirtBlack2 from './shirtBlack2.avif';
import shirtBlack3 from './shirtblack3.avif';
import shirtGreenWomen from './shirt green woman.png'
import shirtGreenWomen2 from './shirtGreenWoman2.avif';
import shirtGreenWomen3 from './shirtGreenWoman3.avif';
import shirtWhiteWomen from './shirt white women.png';
import shirtWhiteWomen2 from './shirtWhiteWomen2.avif';
import shirtWhiteWomen3 from './shirtWhiteWomen3.avif';
import shirtBlueWomen from './shirt blue woman.png';
import shirtBlueWomen2 from './shirtBlueWomen2.avif';
import shirtBlueWomen3 from './shirtBlueWomen3.avif';
import tShirtBlackKids from './t-shirt black kids.png';
import tShirtBlackKids2 from './tShirtBlackKids2.avif';
import tShirtBlackKids3 from './tShirtBlackKids3.avif';
import tShirtBlackWoman from './t-shirt black women.png';
import tShirtBlackWoman2 from './tShirtBlackWoman2.avif';
import tShirtBlackWoman3 from './tShirtBlackWoman3.avif';
import tshirtGreenWoman from './t-shirt green women.png'
import tshirtGreenWoman2 from './tShirtGreenWomen.avif';
import tshirtGreenWoman3 from './tShirtGreenWomen3.avif';
import tShirtGreenKids from './tkids green pic 2.png'
import tShirtGreenKids2 from './t-ShirrtGreenKids2.avif'
import tShirtGreenKids3 from './t-ShirrtGreenKids3.avif'
import tShirtWhiteKids from './t-shirt white kid.png'
import tShirtWhiteKids2 from './tShirtWhitekids2.avif'
import tShirtWhiteKids3 from './tShirtWhitekids3avif.avif'
import sneakerBlue from './sneakers blue.png'
import sneakerBlue2 from './sneakerBlue2.avif'
import sneakerBlue3 from './sneakerBlue3.avif'
import sneakerBlack from './sneakers black.png'
import sneakerBlack2 from './sneakerBlack2.avif'
import sneakerBlack3 from './sneakerBlack3.avif'
import sneakerWhite from './sneakers white.png'
import sneakerWhite2 from './sneakerWhite2.avif'
import sneakerWhite3 from './sneakerWhite3.avif'
import { IconStarFilled  } from '@tabler/icons-react';
import blog3Pic from './blogimg3.avif'
import blog2pic from './blogimg2.png'
import blog1pic from './blogpic1.png'
import blogpic4 from './blogimg4.avif'
import blogimg5 from './blogimg5.avif'
import blogimg6 from './blog6pic.avif'

export const AllProductsArray = {
    productDescriptions: [
        { productDescription: `Current trends and vibrant colors: \n\nKeep up with fashion by choosing clothes inspired by the latest trends. Vibrant colors and modern prints will help you create unique and personal outfits.\n\nFor an impeccable shopping experience: Our team is dedicated to your satisfaction.\n\n Visit our stores or explore the online collection and benefit from personalized advice, fast delivery, and free returns. Discover the new collection and redefine your personal style!` },
        { material: `Current trends and vibrant colors: Keep up with fashion by choosing clothes inspired by the latest trends. Vibrant colors and modern prints will help you create unique and personal outfits. For an impeccable shopping experience: Our team is dedicated to your satisfaction. Visit our stores or explore the online collection and benefit from personalized advice, fast delivery, and free returns. Discover the new collection and redefine your personal style!` },
        { deliveryAndReturns: `Current trends and vibrant colors: Keep up with fashion by choosing clothes inspired by the latest trends. Vibrant colors and modern prints will help you create unique and personal outfits. For an impeccable shopping experience: Our team is dedicated to your satisfaction. Visit our stores or explore the online collection and benefit from personalized advice, fast delivery, and free returns. Discover the new collection and redefine your personal style!` },
    ],
  testimonials:  [
        {
            name: 'Sophia',
            testimony: "Cosmetica is my go-to fashion store! Their collection is always on trend, and the quality is outstanding. Every time I shop here, I feel like I'm indulging in luxury without breaking the bank!",
            rating: 5/5,
            star: IconStarFilled
        },
        {
            name: 'Emma',
            testimony: "The team at Cosmetica truly cares about their customers. They helped me pick the perfect outfit for a special occasion, and I received so many compliments. The experience was amazing from start to finish!",
            rating: 5/5,
            star: IconStarFilled
        },
        {
            name: 'Olivia',
            testimony: "I love that Cosmetica offers the latest fashion trends at reasonable prices. Whether it's a casual outfit or a statement piece, they never disappoint. Plus, their online shopping experience is seamless!",
            rating: 5/5,
            star: IconStarFilled
        },
        {
            name: 'Rachel',
            testimony: "I've shopped at many fashion stores, but Cosmetica stands out for its quality and style. The fabrics feel premium, and the designs are stunning. I always feel confident wearing their pieces!",
            rating: 5/5,
            star: IconStarFilled
        },
        {
            name: 'Lily',
            testimony: "I ordered from Cosmetica online, and my package arrived so quickly! The clothes were beautifully packaged, and everything fit perfectly. I'm definitely coming back for more!",
            rating: 5/5,
            star: IconStarFilled
        },
        {
            name: 'Isabella',
            testimony: "Cosmetica is my little secret for staying fashionable year-round! Their collections are always fresh, and I love how they balance classic elegance with modern trends. Highly recommend!",
            rating: 5/5,
            star: IconStarFilled
        }
    ],

    jeans: [
        {
          id: 1,
          clotheName: 'Blue Jean',
          type: 'Jeans',
          gender: 'MEN',
          stock: 'FULL-STOCK',
          isProduct : true,
          discountPrice: 50.0,
          discount: '50%',
          actualPrice: 100,
          availableStyle: '3 Styles Available',
          mainImg: blueJean,
          carouselImg: [blueJean, blueJeanTwo, blueJeanThree],
          link: 'blue-jean',
          variantImage: [
            { productId: 1, imageUrl: blueJean },
            { productId: 2, imageUrl: whiteJean1 },
            { productId: 3, imageUrl: blackJean },
          ],
          productCategory: 'Advisable',
          order: ['Alphabetically-AZ', 'Alphabetically-ZA', 'Price, from low to high'],
          trending: true,
        },
        {
          id: 2,
          clotheName: 'White Jean',
          type: 'Jeans',
          gender: 'MEN',
          stock: 'FULL-STOCK',
          discountPrice: 50.0,
          discount: '50%',
          isProduct : true,

          actualPrice: 100,
          availableStyle: '3 Styles Available',
          mainImg: whiteJean1,
          carouselImg: [whiteJean1, whiteJean2, whiteJean3],
          link: 'white-jean',
          variantImage: [
            { productId: 2, imageUrl: whiteJean1 },
            { productId: 1, imageUrl: blueJean },
            { productId: 3, imageUrl: blackJean },
          ],
          productCategory: 'Advisable',
          order: ['Price, from low to high'],
          trending: true,
        },
        {
          id: 3,
          clotheName: 'Black Jean',
          type: 'Jeans',
          gender: 'MEN',
          isProduct : true,

          stock: 'PROMOTIONS',
          discountPrice: 50.0,
          discount: '50%',
          actualPrice: 100,
          availableStyle: '3 Styles Available',
          mainImg: blackJean,
          carouselImg: [blackJean, blackJean2, blackJean3],
          link: 'black-jean',
          variantImage: [
            { productId: 3, imageUrl: blackJean },
            { productId: 2, imageUrl: whiteJean1 },
            { productId: 1, imageUrl: blueJean },
          ],
          order: ['Alphabetically-AZ', 'Alphabetically-ZA', 'Price, from low to high'],
        },
        {
          id: 4,
          clotheName: 'Comfort Curves',
          type: 'Jeans',
          gender: 'WOMAN',
          isProduct : true,

          stock: 'FULL-STOCK',
          discountPrice: 50.0,
          discount: '50%',
          actualPrice: 100,
          availableStyle: '3 Styles Available',
          mainImg: comfortCurves,
          carouselImg: [comfortCurves, comfortCurves2, comfortCurves3],
          link: 'comfort-curves',
          variantImage: [
            { productId: 4, imageUrl: comfortCurves },
            { productId: 5, imageUrl: highRiseHustle },
            { productId: 6, imageUrl: vintageVibes },
          ],
          productCategory: 'Advisable',
          order: ['Price, from low to high'],
        },
        {
          id: 5,
          clotheName: 'High Rise Hustle',
          type: 'Jeans',
          gender: 'WOMAN',
          isProduct : true,

          stock: 'FULL-STOCK',
          discountPrice: 150.0,
          discount: '50%',
          actualPrice: 300,
          availableStyle: '3 Styles Available',
          mainImg: highRiseHustle,
          carouselImg: [highRiseHustle, highRiseHustle2, highRiseHustle3],
          link: 'high-rise-hustle',
          variantImage: [
            { productId: 5, imageUrl: highRiseHustle },
            { productId: 4, imageUrl: comfortCurves },
            { productId: 6, imageUrl: vintageVibes },
          ],
          productCategory: 'Advisable',
          order: ['Alphabetically-AZ', 'Alphabetically-ZA', 'Price, from high to low'],
        },
        {
          id: 6,
          clotheName: 'Vintage Vibes',
          type: 'Jeans',
          gender: 'WOMAN',
          isProduct : true,

          stock: 'FULL-STOCK',
          discountPrice: 50.0,
          discount: '50%',
          actualPrice: 100,
          availableStyle: '3 Styles Available',
          mainImg: vintageVibes,
          carouselImg: [vintageVibes, vintageVibes2, vintageVibes3],
          link: 'vintage-vibes',
          variantImage: [
            { productId: 6, imageUrl: vintageVibes },
            { productId: 4, imageUrl: comfortCurves },
            { productId: 5, imageUrl: highRiseHustle },
          ],
          productCategory: 'Advisable',
          order: ['Price, from low to high'],
          trending: true,
        },
      ],
    

      shirt: [
        {
          id: 7,
          clotheName: 'Shirt White',
          type: 'Shirt',
          gender: 'MEN',
          isProduct : true,

          discountPrice: 94.0,
          availableStyle: '3 Styles Available',
          discount: '25%',
          actualPrice: 125.0,
          stock: 'FULL-STOCK',
          mainImg: shirtWhite,
          carouselImg: [shirtWhite, shirtWhite2, shirtWhite3],
          link: 'shirt-white',
          variantImage: [
            { productId: 7, imageUrl: shirtWhite },
            { productId: 8, imageUrl: shirtBlack },
            { productId: 9, imageUrl: shirtGreen },
          ],
          productCategory: 'Advisable',
          order: ['Price, from low to high'],
        },
        {
          id: 8,
          clotheName: 'Shirt Black',
          type: 'Shirt',
          gender: 'MEN',
          isProduct : true,

          discountPrice: 100.0,
          availableStyle: '3 Styles Available',
          discount: '50%',
          actualPrice: 200.0,
          stock: 'STOCK',
          mainImg: shirtBlack,
          carouselImg: [shirtBlack, shirtBlack2, shirtBlack3],
          link: 'shirt-black',
          variantImage: [
            { productId: 8, imageUrl: shirtBlack },
            { productId: 7, imageUrl: shirtWhite },
            { productId: 9, imageUrl: shirtGreen },
          ],
          productCategory: ['Advisable', 'Best-Seller'],
          order: ['Alphabetically-AZ', 'Alphabetically-ZA', 'Price, from high to low'],
          trending: true,
        },
        {
          id: 9,
          clotheName: 'Shirt Green',
          type: 'Shirt',
          gender: 'MEN',
          isProduct : true,

          discountPrice: 94.0,
          availableStyle: '3 Styles Available',
          discount: '25%',
          actualPrice: 125.0,
          stock: 'FULL-STOCK',
          mainImg: shirtGreen,
          carouselImg: [shirtGreen, shirtGreen2, shirtGreen3],
          link: 'shirt-green',
          variantImage: [
            { productId: 9, imageUrl: shirtGreen },
            { productId: 8, imageUrl: shirtBlack },
            { productId: 7, imageUrl: shirtWhite },
          ],
          productCategory: 'Advisable',
          order: ['Price, from low to high'],
        },
        {
          id: 10,
          clotheName: 'Shirt White Women',
          type: 'Shirt',
          gender: 'WOMAN',
          isProduct : true,

          discountPrice: 50.0,
          availableStyle: '2 Styles Available',
          discount: '50%',
          actualPrice: 100.0,
          stock: 'OUT OF STOCK',
          mainImg: shirtWhiteWomen,
          carouselImg: [shirtWhiteWomen, shirtWhiteWomen2, shirtWhiteWomen3],
          link: 'shirt-white-women',
          variantImage: [
            { productId: 10, imageUrl: shirtWhiteWomen },
            { productId: 12, imageUrl: shirtBlueWomen },
            { productId:11, imageUrl: shirtGreenWomen },
          ],
          order: ['Price, from low to high'],
        },
        {
          id: 11,
          clotheName: 'Shirt Green Women',
          type: 'Shirt',
          isProduct : true,

          discountPrice: 50.0,
          availableStyle: '2 Styles Available',
          discount: '50%',
          actualPrice: 100.0,
          gender: 'WOMAN',

          stock: 'STOCK',
          mainImg: shirtGreenWomen,
          carouselImg: [shirtGreenWomen, shirtGreenWomen2, shirtGreenWomen3],
          link: 'shirt-green-women',
          variantImage: [
            { productId: 11, imageUrl: shirtGreenWomen },
            { productId: 12, imageUrl: shirtBlueWomen },
            { productId: 10, imageUrl: shirtWhiteWomen },
          ],
          productCategory: ['Advisable', 'Best-Seller'],
          order: ['Price, from low to high'],
        },
        {
          id: 12,
          clotheName: 'Shirt Blue Women',
          type: 'Shirt',
          gender: 'WOMAN',
          isProduct : true,

          discountPrice: 50.0,
          availableStyle: '2 Styles Available',
          discount: '50%',
          actualPrice: 100.0,
          stock: 'PROMOTIONS',
          mainImg: shirtBlueWomen,
          carouselImg: [shirtBlueWomen, shirtBlueWomen2, shirtBlueWomen3],
          link: 'shirt-blue-women',
          variantImage: [
            { productId: 12, imageUrl: shirtBlueWomen },
            { productId: 10, imageUrl: shirtWhiteWomen },
            { productId: 11, imageUrl: shirtGreenWomen },
          ],
          order: ['Price, from low to high'],
          trending: true,
        },
      ],

      tShirt: [
        {
          id: 13,
          clotheName: 'T-Shirt Black Kids',
          type: 'T-Shirt',
          discountPrice: 50.0,
          isProduct : true,


          availableStyle: '2 Styles Available',
          discount: '50%',
          actualPrice: 100.0,
          stock: 'OUT OF STOCK',
          mainImg: tShirtBlackKids,
          carouselImg: [tShirtBlackKids, tShirtBlackKids2, tShirtBlackKids3],
          link: 't-shirt-black-kids',
          variantImage: [
            { productId: 13, imageUrl: tShirtBlackKids },
            { productId: 14, imageUrl: tShirtWhiteKids },
            { productId: 15, imageUrl: tShirtGreenKids },
          ],
          order: ['Price, from low to high'],
        },
        {
          id: 14,
          clotheName: 'T-Shirt White Kids',
          type: 'T-Shirt',
          discountPrice: 50.0,
          availableStyle: '2 Styles Available',
          discount: '50%',
          isProduct : true,

          actualPrice: 100.0,
          stock: 'PROMOTIONS',
          mainImg: tShirtWhiteKids,
          carouselImg: [tShirtWhiteKids, tShirtWhiteKids2, tShirtWhiteKids3],
          link: 't-shirt-white-kids',
          variantImage: [
            { productId: 14, imageUrl: tShirtWhiteKids },
            { productId: 13, imageUrl: tShirtBlackKids },
            { productId: 15, imageUrl: tShirtGreenKids },
          ],
          order: ['Price, from low to high'],
        },
        {
          id: 15,
          clotheName: 'T-Shirt Green Kids',
          type: 'T-Shirt',
          isProduct : true,

          discountPrice: 50.0,
          availableStyle: '2 Styles Available',
          discount: '50%',
          actualPrice: 100.0,
          stock: 'OUT OF STOCK',
          mainImg: tShirtGreenKids,
          carouselImg: [tShirtGreenKids, tShirtGreenKids2, tShirtGreenKids3],
          link: 't-shirt-green-kids',
          variantImage: [
            { productId: 15, imageUrl: tShirtGreenKids },
            { productId: 13, imageUrl: tShirtBlackKids },
            { productId: 14, imageUrl: tShirtWhiteKids },
          ],
          order: ['Price, from low to high'],
          promotion: true
        },
        {
          id: 16,
          clotheName: 'T-Shirt Black Women',
          type: 'T-Shirt',
          gender: 'WOMAN',
          isProduct : true,

          discountPrice: 50.0,
          availableStyle: '2 Styles Available',
          discount: '50%',
          actualPrice: 100.0,
          stock: 'OUT OF STOCK',
          mainImg: tShirtBlackWoman,
          carouselImg: [tShirtBlackWoman, tShirtBlackWoman2, tShirtBlackWoman3],
          link: 't-shirt-black-women',
          variantImage: [
            { productId: 16, imageUrl: tShirtBlackWoman },
            { productId: 17, imageUrl: tshirtGreenWoman },
          ],
          order: ['Price, from low to high'],
        },
        {
          id: 17,
          clotheName: 'T-Shirt Green Women',
          type: 'T-Shirt',
          gender: 'WOMAN',
          isProduct : true,

          discountPrice: 50.0,
          availableStyle: '2 Styles Available',
          discount: '50%',
          actualPrice: 100.0,
          stock: 'FULL-STOCK',
          mainImg: tshirtGreenWoman,
          carouselImg: [tshirtGreenWoman, tshirtGreenWoman2, tshirtGreenWoman3],
          link: 't-shirt-green-women',
          variantImage: [
            { productId: 17, imageUrl: tshirtGreenWoman },
            { productId: 16, imageUrl: tShirtBlackWoman },
          ],
          productCategory: 'Advisable',
          order: ['Price, from low to high'],
          trending: true,
        },
      ],
      sneakers: [
        {
          id: 18,
          clotheName: 'Sneaker Blue',
          type: 'Sneakers',
          isProduct : true,

          discountPrice: 50.0,
          availableStyle: '2 Styles Available',
          discount: '50%',
          actualPrice: 100.0,
          stock: 'FULL-STOCK',
          mainImg: sneakerBlue,
          carouselImg: [sneakerBlue, sneakerBlue2, sneakerBlue3],
          link: 'sneaker-blue',
          variantImage: [
            { productId: 18, imageUrl: sneakerBlue },
            { productId: 19, imageUrl: sneakerBlack },
            { productId: 20, imageUrl: sneakerWhite },
          ],
          productCategory: 'Advisable',
          order: ['Price, from low to high'],
        },
        {
          id: 19,
          clotheName: 'Sneaker Black',
          type: 'Sneakers',
          isProduct : true,

          discountPrice: 50.0,
          availableStyle: '2 Styles Available',
          discount: '50%',
          actualPrice: 100.0,
          stock: 'FULL-STOCK',
          mainImg: sneakerBlack,
          carouselImg: [sneakerBlack, sneakerBlack2, sneakerBlack3],
          link: 'sneaker-black',
          variantImage: [
            { productId: 19, imageUrl: sneakerBlack },
            { productId: 18, imageUrl: sneakerBlue },
            { productId: 20, imageUrl: sneakerWhite },
          ],
          productCategory: 'Advisable',
          order: ['Alphabetically-AZ', 'Alphabetically-ZA', 'Price, from low to high'],
          trending: true,
        },
        {
          id: 20,
          clotheName: 'Sneaker White',
          type: 'Sneakers',
          isProduct : true,

          discountPrice: 50.0,
          availableStyle: '2 Styles Available',
          discount: '50%',
          actualPrice: 100.0,
          stock: 'FULL-STOCK',
          mainImg: sneakerWhite,
          carouselImg: [sneakerWhite, sneakerWhite2, sneakerWhite3],
          link: 'sneaker-white',
          variantImage: [
            { productId: 20, imageUrl: sneakerWhite },
            { productId: 19, imageUrl: sneakerBlack },
            { productId: 18, imageUrl: sneakerBlue },
          ],
          productCategory: 'Advisable',
          order: ['Price, from low to high'],
          trending: true,
        },
      ],

   blogs: [
    {
      id: 1,
      title: 'The Evolution of Sustainable Fashion: Trends and Innovations',
      img: blog1pic,
      preview: "In recent years, sustainable fashion has emerged as a powerful movement within the industry, driven by increasing awareness of environmental and social issues. From eco-friendly materials to ethical production practices, let's explore the evolution of sustainable fashion and the trends and innovations shaping its future.",
      fullBlog: ["In recent years, sustainable fashion has emerged as a powerful movement within the industry, driven by increasing awareness of environmental and social issues. From eco-friendly materials to ethical production practices, let's explore the evolution of sustainable fashion and the trends and innovations shaping its future. ", "1. Rise of Eco-Friendly Fabrics: Traditional fashion materials like cotton and polyester have significant environmental impacts, leading designers to seek alternatives. Eco-friendly fabrics such as organic cotton, hemp, bamboo, and Tencel are gaining popularity for their lower ecological footprint and biodegradability.", "2. Circular Fashion: The concept of circular fashion aims to eliminate waste and pollution by designing clothing that can be recycled, upcycled, or biodegraded at the end of its lifecycle. Brands are adopting circularity through initiatives like clothing rental, garment recycling programs, and designing for longevity. ", "3. Ethical Supply Chains: Consumers are demanding transparency and accountability from fashion brands regarding their supply chains. Ethical production practices, fair wages, and safe working conditions are becoming integral to sustainable fashion, with certifications like Fair Trade and B Corp driving industry standards. ", "4. Slow Fashion Movement: In contrast to fast fashion's rapid production cycles and disposable mentality, the slow fashion movement advocates for mindful consumption and investment in quality, timeless pieces. Slow fashion encourages consumers to cherish their clothing, repair and maintain them, and prioritize longevity over trend-driven purchases.", "5. Tech-Driven Innovation: Technology plays a crucial role in advancing sustainability in fashion, with innovations such as 3D printing, digital design tools, and blockchain tracing revolutionizing supply chain transparency and efficiency. Additionally, biofabrication and lab-grown materials offer promising alternatives to conventional textiles, reducing the industry's reliance on natural resources.", "6. Consumer Empowerment: As awareness of sustainability grows, consumers are driving change by making conscious purchasing decisions and supporting brands that align with their values. Social media and online platforms empower consumers to hold brands accountable, advocate for transparency, and foster a community dedicated to sustainable fashion.", "The evolution of sustainable fashion is a journey towards a more responsible and ethical industry. By embracing innovation, collaboration, and consumer education, we can create a fashion ecosystem that respects both people and the planet." ],
      date: 'Feb 28, 2022'
    },
    {
      id: 2,
      img: blog2pic,
      title: 'Fashion Icons Through the Decades: Timeless Style Lessons',
      preview: "Fashion has always been influenced by iconic figures whose style transcends time and leaves a lasting impact on the industry. Let's take a journey through the decades and explore the fashion icons whose timeless elegance continues to inspire us today.",
      fullBlog: ["Fashion has always been influenced by iconic figures whose style transcends time and leaves a lasting impact on the industry. Let's take a journey through the decades and explore the fashion icons whose timeless elegance continues to inspire us today. ", " 1920s: Coco Chanel Coco Chanel revolutionized women's fashion in the 1920s with her modern and liberated approach to clothing. She popularized the little black dress, tailored suits, and the concept of effortless chic, proving that simplicity is the ultimate sophistication.", "1950s: Audrey Hepburn Audrey Hepburn epitomized elegance and grace in the 1950s with her iconic roles and impeccable style. Her little black dress in 'Breakfast at Tiffany's' and timeless Givenchy ensembles showcased a perfect balance of sophistication and simplicity.", "1960s: Twiggy Twiggy, the quintessential '60s fashion icon, embodied the spirit of the swinging sixties with her youthful charm and mod style. Her pixie haircut, bold eyelashes, and mini skirts defined an era of fashion experimentation and liberation. ", "1970s: Farrah Fawcett Farrah Fawcett's effortlessly cool style defined the 1970s, from her iconic feathered hair to her laid-back California vibes. Her signature look of flared jeans, crop tops, and oversized sunglasses epitomized the casual yet glamorous spirit of the decade.", "1980s: Princess Diana Princess Diana captivated the world with her impeccable sense of style and her ability to effortlessly transition from glamorous gowns to chic casualwear. Her bold fashion choices, including power suits and statement jewelry, continue to inspire modern fashion trends.", "1990s: Kate Moss Kate Moss emerged as the ultimate '90s style icon with her effortless cool and grunge-inspired looks. Her minimalist approach to fashion, characterized by slip dresses, leather jackets, and skinny jeans, defined the decade's aesthetic of understated glamour.", "2000s: Sarah Jessica Parker As Carrie Bradshaw in ' Sarah Jessica Parker became a fashion icon of the 2000s, inspiring women worldwide with her eclectic and adventurous style. Her love for designer labels, bold accessories, and fearless experimentation made her a fashion trailblazer.", "2010s: Rihanna Rihanna redefined modern fashion in the 2010s with her fearless approach to style and her ability to push boundaries. From red carpet couture to streetwear chic, her ever-evolving looks reflect her boldness and individuality, inspiring a new generation of fashion enthusiasts.", "From Coco Chanel's timeless elegance to Rihanna's daring experimentation, these fashion icons have left an indelible mark on the industry, reminding us that true style knows no bounds and that confidence is the ultimate accessory. " ],
      date: 'Feb 6, 2022'
    },
    {
      id: 3,
      title: 'How to Build a Capsule Wardrobe: Essential Tips for Every Fashionista',
      preview: "In a world where less is more, the concept of a capsule wardrobe has gained popularity among fashion enthusiasts. A capsule wardrobe consists of a curated collection of timeless, versatile pieces that can be mixed and matched to create a wide range of outfits, making getting dressed effortless and stylish. Here are some essential tips for building your own capsule wardrobe:",
      fullBlog: ["Start with the Basics: Begin by selecting high-quality basics that form the foundation of your wardrobe. This includes items like a white button-down shirt, a classic pair of jeans, a tailored blazer, and a little black dress. ", "Choose Versatile Pieces: Opt for versatile pieces that can be easily styled in multiple ways. Look for items that can transition seamlessly from day to night and from casual to formal occasions.", "Focus on Quality Over Quantity: Invest in quality pieces that will stand the test of time. Choose fabrics that are durable and easy to care for, ensuring that your wardrobe staples last for years to come.", "Stick to a Color Palette: Select a cohesive color palette for your capsule wardrobe to ensure that all pieces can be mixed and matched effortlessly. Neutral tones like black, white, grey, and beige are versatile and timeless.", "Add Statement Pieces: While the focus of a capsule wardrobe is on simplicity, don't be afraid to add a few statement pieces to inject personality and style into your outfits. This could be a bold print, a pop of color, or a unique accessory.", "Consider Your Lifestyle: Tailor your capsule wardrobe to suit your lifestyle and personal preferences. Think about the activities you engage in regularly and select pieces that are appropriate and functional for your daily routine.", "Edit Regularly: Keep your capsule wardrobe fresh and relevant by editing it regularly. Remove items that no longer serve you or that no longer fit your style aesthetic, and replace them with new additions that complement your existing pieces.", "By following these essential tips, you can build a capsule wardrobe that is chic, functional, and perfectly tailored to your individual style.", ],
      date: 'Feb 4, 2025',
      img: blog3Pic,
    },
    {
      id: 4,
      title: 'Accessorizing 101: Elevate Your Outfits with the Perfect Accessories',
      preview: "Accessories are the ultimate style secret, capable of taking any outfit from ordinary to extraordinary. In this guide, we'll explore the art of accessorizing and discover how the right accessories can elevate your wardrobe to new heights.",
      fullBlog: ["Understanding the Basics:Learn the fundamental principles of accessorizing, including balance, proportion, and harmony.Discover the importance of choosing accessories that complement your outfit without overpowering it. ", "Building Your Collection:Explore essential accessories every wardrobe should have, from statement jewelry to versatile scarves and belts.Get tips on curating a collection that reflects your personal style and complements your wardrobe.", "Mixing and Matching:Experiment with different combinations of accessories to create unique looks that express your individuality.Learn how to layer accessories effectively to add depth and visual interest to your outfits.", "Making a Statement:Find out how statement accessories can instantly elevate even the simplest of outfits.Get inspiration for incorporating bold pieces into your wardrobe and making a style statement.", "Adapting to Occasions:Discover how to choose accessories appropriate for different occasions, whether it's a casual day out or a formal event. Learn the art of accessorizing for specific settings and dress codes to ensure you always look polished and put-together.", "Expressing Your Personality:Your accessories are an extension of your personality—learn how to use them to express yourself and showcase your individual style.Get creative with accessories that reflect your interests, passions, and unique sense of style.", "Edit Regularly: Keep your capsule wardrobe fresh and relevant by editing it regularly. Remove items that no longer serve you or that no longer fit your style aesthetic, and replace them with new additions that complement your existing pieces.", "Conclusion: With the right accessories, the possibilities are endless. Whether you're looking to add a pop of color, make a bold statement, or simply elevate your everyday look, mastering the art of accessorizing is the key to unlocking your full style potential.", ],
      date: 'Feb 8, 2025',
      img: blogpic4,
    },
    {id: 5, 
      title: 'How to Style Denim: Tips for Creating Effortlessly Chic Outfits',
      preview: "Denim is a timeless wardrobe staple that can be dressed up or down for any occasion. Whether you're running errands, meeting friends for brunch, or heading out for a night on the town, denim is a versatile and stylish choice. Here are some tips for styling denim to create effortlessly chic outfits:",
      fullBlog: ["Denim is a timeless wardrobe staple that can be dressed up or down for any occasion. Whether you're running errands, meeting friends for brunch, or heading out for a night on the town, denim is a versatile and stylish choice. Here are some tips for styling denim to create effortlessly chic outfits: ", "1. Elevate Your Basics: Start with a classic pair of jeans and a simple white t-shirt for a foolproof casual look. Add a blazer, statement jewelry, and heels to elevate the outfit for a more polished and sophisticated vibe.", "2. Mix and Match: Experiment with different denim washes and silhouettes to create interesting contrasts and textures. Pair light-wash jeans with a dark denim jacket or mix skinny jeans with a relaxed-fit denim shirt for a modern twist.", "3. Play with Proportions: Balance the casual nature of denim with structured pieces like a tailored blazer, a crisp button-down shirt, or a structured handbag. Mixing proportions creates visual interest and adds a touch of sophistication to your outfit.", "4. Add Layers: Layering is key to creating stylish and dynamic denim outfits. Try layering a denim jacket over a dress, a turtleneck under a denim shirt, or a cropped sweater over high-waisted jeans for a cozy and chic look.", "5. Accessorize Thoughtfully: Accessories can take your denim outfit to the next level. Experiment with statement belts, bold scarves, oversized sunglasses, and sleek footwear to add personality and flair to your look. Don't be afraid to mix metals, textures, and colors for a fashion-forward touch.", "6. Embrace Double Denim: The Canadian tuxedo is back in style, and double denim outfits are a chic and effortless choice. Pair a denim shirt with jeans in a similar wash for a monochromatic look, or mix different denim hues for a modern and eclectic outfit.", "7. Dress Up Your Denim: Don't be afraid to dress up your denim for special occasions. Pair dark-wash jeans with a silk blouse, strappy heels, and statement earrings for a sophisticated evening look that's both stylish and comfortable.", "By following these tips, you can create effortlessly chic denim outfits that are versatile, stylish, and perfect for any occasion. Whether you're a denim devotee or new to the trend, denim is a timeless and versatile choice that will never go out of style.", ],
      date: 'Feb 10, 2025',
      img: blogimg5,
    },
    {
      id: 6,
      title: 'The Power of Color: How to Use Color Theory to Elevate Your Style',
      preview: "Color plays a powerful role in fashion, influencing our mood, perception, and style choices. By understanding color theory and how different hues interact, you can create visually appealing outfits that reflect your personality and enhance your overall look. Here are some tips for using color theory to elevate your style:",
      fullBlog: ["Color plays a powerful role in fashion, influencing our mood, perception, and style choices. By understanding color theory and how different hues interact, you can create visually appealing outfits that reflect your personality and enhance your overall look. Here are some tips for using color theory to elevate your style: ", "1. Start with the Basics: Familiarize yourself with the color wheel and the relationships between different hues. The color wheel is divided into primary, secondary, and tertiary colors, as well as warm and cool tones. Understanding these concepts will help you create harmonious color combinations.", "2. Experiment with Monochromatic Looks: Monochromatic outfits feature different shades and tints of the same color, creating a cohesive and sophisticated look. Try pairing different textures and fabrics in the same color family for added depth and visual interest.", "3. Mix Complementary Colors: Complementary colors are opposite each other on the color wheel and create a striking contrast when paired together. Experiment with complementary color combinations like blue and orange, red and green, or yellow and purple for bold and eye-catching outfits.", "4. Play with Analogous Colors: Analogous colors are adjacent to each other on the color wheel and create a harmonious and cohesive look when paired together. Try combining colors like blue and green, red and orange, or yellow and green for a subtle and sophisticated outfit.", "5. Add Accent Colors: Accent colors are bold hues that add visual interest and contrast to an outfit. Use accent colors sparingly to draw attention to specific areas or accessories, creating a focal point in your look. Experiment with bright accessories, statement shoes, or colorful outerwear to add a pop of color to your outfit.", "6. Consider Color Temperature: Warm colors like red, orange, and yellow create a sense of energy and vibrancy, while cool colors like blue, green, and purple evoke calm and tranquility. Consider the mood and atmosphere you want to convey with your outfit and choose colors that reflect that intention.", "7. Trust Your Instincts: Ultimately, fashion is a form of self-expression, and your personal style should reflect your unique personality and preferences. Trust your instincts when experimenting with color and have fun exploring different combinations and palettes to create looks that make you feel confident and stylish.", "By incorporating color theory into your style choices, you can create visually appealing outfits that reflect your personality, enhance your mood, and elevate your overall look. Whether you prefer bold and vibrant hues or subtle and understated tones, understanding color theory is a valuable tool for expressing yourself through fashion.", ],
      date: 'Feb 12, 2025',
      img: blogimg6,
    }
  ], 
  faqData : [
    { id:1,
      category: "Placing an Order",
      questions: [
        {
          question: "How can I track my order?",
          answer: "You can track your order by visiting the 'Order Status' page and entering your order details."
        },
        {
          question: "Can I modify or cancel an already placed order?",
          answer: "Once an order is placed, modifications or cancellations depend on processing status. Contact support for assistance."
        }
      ]
    },
    { id:2,
      category: "Shipping and Delivery",
      questions: [
        {
          question: "What shipping options are available?",
          answer: "We offer standard, express, and international shipping. Delivery times vary based on location."
        },
        {
          question: "Can I track international delivery?",
          answer: "Yes, international orders come with tracking. Use your tracking number on our website."
        }
      ]
    },
    { id:3,
      category: "Returns and Refunds",
      questions: [
        {
          question: "What is the return policy?",
          answer: "Items can be returned within 30 days of receipt, provided they are in original condition."
        },
        {
          question: "How do I initiate a return?",
          answer: "Visit the 'Returns' page and follow the instructions to process your return."
        }
      ]
    },
    { id:4,
      category: "Support and Contact",
      questions: [
        {
          question: "How do I contact customer support?",
          answer: "You can reach us via email, chat, or phone. Our support team is available 24/7."
        },
        {
          question: "Where can I find troubleshooting guides?",
          answer: "Our Help Center has detailed guides on troubleshooting common issues."
        }
      ]
    }
  ],
  privacyPoliy: [
    "At Store, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, disclose, and protect your information when you visit our website or make a purchase from us.",
    "Information We Collect:",
    "When you visit our website, we may collect certain information about your device, including your IP address, browser type, and operating system. We also collect information about your browsing behavior on our site, such as the pages you visit and the products you view.",
    "Use of Information:",
    "We use the information we collect to provide and improve our services, communicate with you, process your orders, and personalize your shopping experience. We may also use your information to send you promotional offers and marketing communications.",
    "Disclosure of Information:",
    "We may share your information with third-party service providers who assist us in operating our website, conducting our business, or servicing you. We may also share your information when required by law or to protect our rights, property, or safety.",
    "Data Security:",
    "We take reasonable measures to protect the security of your personal information and prevent unauthorized access, use, or disclosure. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.",
    "Your Rights:",
    "You have the right to access, correct, or delete your personal information at any time. You may also opt-out of receiving promotional communications from us by following the instructions provided in those communications.",
    "Changes to This Policy:",
    "We reserve the right to update or change this Privacy Policy at any time. Any changes will be effective immediately upon posting on our website. We encourage you to review this Privacy Policy periodically for any updates or changes.",
    "By using our website, you consent to the terms of this Privacy Policy. If you have any questions or concerns about our Privacy Policy or the handling of your personal information, please contact us through our contact page."
  ]

}